<template>
  <div v-if="this.resultData" style='padding: 2rem'>
    <chart v-for="(result,index) in this.resultData"
              :key="result.id"
              :result="result"
              :index="index"
              :options="options"/>
  </div>
</template>
<script>

import componentState from '@/mixins/component-state'
import mixin from '../tabs'
import auth from '@/mixins/auth'
import Chart from '@/components/Charts/Chart'

export default {
  components: {
    Chart
  },
  computed: {
    resultData: function () {
      return this.$store.getters.getQuestionsWithAnswers
    }
  },
  mixins: [componentState, mixin, auth],
  data: function () {
    return {
      selectOptions: '',
      isHidden: false,
      options: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        plugins: {
          datalabels: {
            color: 'black',
            textAlign: 'center',
            font: {
              weight: 'bold',
              size: 12
            },
            formatter: (value, context) => {
              return this.getPercent(context.chart.data.datasets[0].data, context.dataIndex) + '\n\n' +
                  context.chart.data.labels[context.dataIndex]
            }
          }
        }
      }
    }
  },
  methods: {
    getPercent: function (array, index) {
      const sum = array.reduce((prev, curr) => prev + curr)
      return Math.round(array[index] / sum * 100) + '%'
    }
  }
}
</script>
